import { useStaticQuery, graphql } from 'gatsby'

export function useStreamingServiceNav() {
  const {
    allStreamNav: { nodes },
  } = useStaticQuery(
    graphql`
      query StreamingServiceNavQuery {
        allStreamNav {
          nodes {
            groupName
            entries {
              id
              title
            }
          }
        }
      }
    `,
  )

  return nodes
}
